import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../utils/LoginPage.css'; // Asegúrate de que el archivo CSS esté en la ubicación correcta
import logo from '../components/public/login.png';

const LoginPage = () => {
  const [usuario, setUsuario] = useState(''); // Cambiar a "usuario"
  const [password, setPassword] = useState('');
  const [error, setError] = useState(''); // Estado para el mensaje de error
  const navigate = useNavigate(); // Hook para redirigir
  
  const API_URL = process.env.REACT_APP_API_URL 
    ? process.env.REACT_APP_API_URL
    : 'http://localhost:4000';

    

const handleSubmit = async (event) => {
  event.preventDefault();
  try {
    const response = await axios.post(`${API_URL}/usuarios/login`, { usuario, password }, {
      withCredentials: true,
    });

    if (response.status === 200) {
    const { id_usuario, nombre, usuario, rol, token } = response.data;

    localStorage.setItem('id_usuario', id_usuario);
    localStorage.setItem('nombre_usuario', nombre);
    localStorage.setItem('rol_usuario', rol);
    localStorage.setItem('token', token); // ✅ AÑADIR ESTO

    navigate('/panel');
  }

  } catch (error) {
    console.error('Error en la solicitud:', error);
    setError('Usuario o contraseña incorrectos');
  }
};

  
  
  return (
    <div className="login-container">
      <div className="login-box">
        <h1>Iniciar sesión</h1>
        <div className="intro-image">
          <img src={logo} alt="Logo" />
        </div>
        
        <form onSubmit={handleSubmit}>
        
          <label>
            Usuario:
            <input
              type="text"
              value={usuario} // Cambiar a "usuario"
              onChange={(e) => setUsuario(e.target.value)}
              required
              placeholder="pepitoperez@gmail.com"
            />
          </label>
          
          <label>
            Contraseña:
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder=".........."
            />
          </label>
          
          {error && <p className="error-message">{error}</p>} {/* Mostrar mensaje de error */}
          <button type="submit">Iniciar sesión</button>
        </form>
        
      </div>
    </div>
  );
};

export default LoginPage;